import { mapActions } from 'vuex';
import Events from '_utils/events';
import QuotationService from '_services/rest/modules/quotation';
import { _DELETE_TAB_ } from './QuotationModel';

export default {
  name: 'quotation-actions',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteTab() {
      this.close();
      Events.$emit(_DELETE_TAB_, this.selectedQuotation);
      window.scrollTo(0, 0);
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.deleteQuotation(this.selectedQuotation.id)
        .then(() => {
          this.close();
          this.$router.push('/admin/orcamentos/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Orçamento deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    approveQuotation() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.updateStatus(this.selectedQuotation.id, 'approved', true)
        .then(() => {
          this.activeAlert({ message: 'Orçamento aprovado com sucesso', theme: 'success' });
          this.close();
          Events.$emit('update:pagination', false);
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
